'use strict';

import $ from 'jquery';
import 'slick-carousel';

export default class PageBanner {
  constructor() {
    let $bannerCarousel = $('.page-banner__carousel-container');

    $bannerCarousel.slick({
      dots: false,
      infinite: true,
      arrows: true,
      autoplay: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      prevArrow: '<button class="slick-arrow slick-prev"><span class="icon icon-angle-left"></span><span class="label"></span></button>',
      nextArrow: '<button class="slick-arrow slick-next"><span class="label"></span><span class="icon icon-angle-right"></span></button>',
      appendArrows: $('.page-banner__carousel-nav')
    })
  }
}
